import styled from "styled-components";

export const StyleProfile = styled.div`
  width: 100%;
  color: #d8e2ee;

  .mypage-page-head {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    color: #d8e7f2;
  }

  .mypage-page-head svg {
    width: 28px;
    height: 28px;
    color: #a9bfce;
  }

  .mypage-page-head h1 {
    margin: 0;
    color: #ffffff;
    font-family: var(--crypto-display-font);
    font-size: 28px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: 0;
  }

  .mypage-main-grid {
    display: grid;
    gap: 22px;
  }

  .mypage-panel {
    min-width: 0;
    border-radius: 8px;
    background: var(--crypto-surface);
    overflow: hidden;
  }

  .mypage-section-head {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    padding: 24px 28px 22px;
    border-bottom: 1px solid rgba(166, 196, 213, 0.18);
  }

  .mypage-section-head h2 {
    margin: 0;
    color: #ffffff;
    font-size: 21px;
    line-height: 1.2;
    font-weight: 700;
    letter-spacing: 0;
  }

  .mypage-section-head p {
    margin: 12px 0 0;
    color: #a8b9c8;
    font-size: 14px;
    line-height: 1.55;
    font-weight: 500;
  }

  .section-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    width: max-content;
    min-height: 24px;
    border-radius: 999px;
    padding: 0 10px;
    color: #e6ffe8;
    background: #169b31;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
  }

  .mypage-field-grid {
    display: grid;
    gap: 18px;
    padding: 24px 28px 28px;
  }

  .mypage-field-grid.compact {
    grid-template-columns: 1fr;
  }

  .mypage-field {
    min-width: 0;
  }

  .mypage-field label,
  .mypage-form label {
    display: grid;
    gap: 8px;
    color: #a8b9c8;
    font-size: 13px;
    line-height: 1.2;
    font-weight: 700;
  }

  .mypage-readonly-value,
  .mypage-form input {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    min-height: 46px;
    border: 1px solid var(--crypto-border);
    border-radius: 8px;
    padding: 0 14px;
    color: #f3f8fb;
    background: var(--crypto-surface-3);
    font: inherit;
    font-size: 15px;
    font-weight: 500;
    outline: 0;
  }

  .mypage-readonly-value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mypage-form {
    display: grid;
    gap: 18px;
    padding: 24px 28px 28px;
  }

  .mypage-form input:focus {
    border-color: #789bad;
    box-shadow: 0 0 0 2px rgba(120, 155, 173, 0.18);
  }

  .mypage-balance-list {
    display: grid;
    padding: 8px 28px 18px;
  }

  .mypage-balance-row {
    display: grid;
    grid-template-columns: minmax(120px, 0.7fr) minmax(0, 1fr);
    gap: 16px;
    align-items: center;
    min-height: 54px;
    border-bottom: 1px solid rgba(166, 196, 213, 0.14);
  }

  .mypage-balance-row:last-child {
    border-bottom: 0;
  }

  .mypage-balance-row span {
    color: #a8b9c8;
    font-size: 14px;
    font-weight: 700;
  }

  .mypage-balance-row strong {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    gap: 4px;
    min-width: 0;
    color: #ffffff;
    font-size: 17px;
    line-height: 1.2;
    font-weight: 700;
    text-align: right;
    word-break: break-all;
  }

  .mypage-balance-row em {
    color: #a8b9c8;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
  }

  .primary-button,
  .ghost-button,
  .logout-button,
  .mypage-wallet-button,
  .mypage-link-card {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    border-radius: 8px;
    padding: 0 16px;
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition:
      background 160ms ease,
      border-color 160ms ease,
      color 160ms ease;
  }

  .primary-button {
    width: 100%;
    border: 0;
    color: #06110a;
    background: var(--crypto-green);
  }

  .primary-button:disabled {
    cursor: default;
    opacity: 0.58;
  }

  .ghost-button {
    border: 1px solid var(--crypto-border);
    color: #d7e7ef;
    background: var(--crypto-surface-raised);
  }

  .ghost-button:hover,
  .mypage-link-card:hover {
    background: #224a58;
    border-color: rgba(166, 196, 213, 0.34);
  }

  .mypage-link-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding: 12px 28px 18px;
  }

  .mypage-wallet-cta {
    padding: 24px 28px 0;
  }

  .mypage-wallet-button {
    width: 100%;
    border: 0;
    color: #06110a;
    background: var(--crypto-green);
  }

  .mypage-wallet-button:hover {
    background: #63ff80;
  }

  .mypage-link-card {
    min-width: 0;
    border: 1px solid var(--crypto-border);
    color: #f3f8fb;
    background: var(--crypto-surface-3);
    text-align: center;
  }

  .logout-button {
    width: calc(100% - 56px);
    margin: 0 28px 28px;
    border: 1px solid rgba(255, 116, 116, 0.28);
    color: #ffc7c7;
    background: rgba(255, 116, 116, 0.08);
  }

  .logout-button:hover {
    background: rgba(255, 116, 116, 0.13);
  }

  .mypage-notice-backdrop {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(5, 8, 13, 0.72);
    backdrop-filter: blur(4px);
  }

  .mypage-notice-panel {
    width: min(360px, 100%);
    border-radius: 8px;
    border: 1px solid var(--crypto-border);
    background: var(--crypto-surface);
    padding: 24px;
    text-align: center;
    box-shadow: 0 22px 52px rgba(0, 0, 0, 0.42);
    animation: mypagePanelIn 160ms ease both;
  }

  .mypage-notice-panel strong {
    display: block;
    color: #ffffff;
    font-size: 20px;
    font-weight: 700;
  }

  .mypage-notice-panel p {
    margin: 12px 0 18px;
    color: #c4d2dd;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 500;
  }

  .mypage-notice-panel.success {
    border-color: rgba(89, 244, 119, 0.34);
  }

  .mypage-notice-panel.error {
    border-color: rgba(255, 103, 103, 0.36);
  }

  .mypage-notice-panel button {
    width: 100%;
    height: 42px;
    border: 0;
    border-radius: 8px;
    color: #06110a;
    background: var(--crypto-green);
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
  }

  @keyframes mypagePanelIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (min-width: 760px) {
    .mypage-section-head {
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: start;
    }

    .mypage-field-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .mypage-field-grid.compact {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .mypage-form {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      align-items: end;
    }
  }

  @media (max-width: 560px) {
    .mypage-page-head {
      margin-bottom: 18px;
    }

    .mypage-section-head,
    .mypage-field-grid,
    .mypage-form,
    .mypage-wallet-cta,
    .mypage-link-grid {
      padding-left: 18px;
      padding-right: 18px;
    }

    .mypage-link-grid {
      grid-template-columns: 1fr;
    }

    .mypage-balance-row {
      grid-template-columns: 1fr;
      gap: 5px;
      padding: 12px 0;
    }

    .mypage-balance-row strong {
      justify-content: flex-start;
      text-align: left;
    }

    .logout-button {
      width: calc(100% - 36px);
      margin-left: 18px;
      margin-right: 18px;
    }
  }
`;
